<footer id="footer" class="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="logo">S9</div>
        </div>
      </div>
      <div class="row gy-4">
        <div class="col-md-2">
          <div class="menu-links">
            <a>Home</a>
            <a (click)="getWebpages('about')">About</a>
            <a>Careers</a>
            <a>Newsroom</a>
            <a>Safety</a>
          </div>
        </div>
        <div class="col-md-2">
          <div class="menu-links">
            <a (click)="getWebpages('cancellationPolicy')">Cancellation Policy</a>
            <a>Help</a>
            <!-- <a (click)="getWebpages('privacyPolicy')">Privacy</a> -->
            <a (click)="getWebpages('privacyPolicy')">Privacy</a>

            <a (click)="getWebpages('termsAndConditions')">Terms</a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="adress-area">
            <h3>Our Address</h3>
            <p>Siby Logistics Private Limited (S9 Trucks),</p>
            <p>1-63/C/8/2, 104, 2nd Floor, Siri Sampada Hi-Tech,
              Kavuri Hills, Madhapur, Hyderabad-81.
              Telangana, India.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="adress-area">
            <h3>Customer Care</h3>
            <p>+91- 90592 82736</p>
            <h3>Support E-Mail :</h3>
            <p>contact@s9trucks.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-social">
    <div class="social">
      <span><img src="../../../assets/img/social-fb.svg" alt=""></span>
      <span><img src="../../../assets/img/social-twitter.svg" alt=""></span>
      <span><img src="../../../assets/img/social-plus.svg" alt=""></span>
      <span><img src="../../../assets/img/social-in.svg" alt=""></span>
    </div>
  </div>

  <div class="container">
    <div class="copyright">
      Copyright 2022 ©<strong><span>Siby Logistics Private Limited.</span></strong>. All Rights Reserved
    </div>
    <!-- <div class="credits">
        Designed by <a href="#">Hardwin Software Solutions</a>
      </div> -->
  </div>
</footer>
